import { useEffect, useState } from "react"
import { Dayjs } from "utils/dayjs"
import FinanceService from "services/FinanceService"

export default function useBookingPeriod() {
    const [bookingPeriod, setBookingPeriod] = useState<Dayjs | null>()

    useEffect(() => {
        const getBookingPeriod = async () => {
            const newBookingPeriod = await FinanceService.getBookingPeriod()
            setBookingPeriod(newBookingPeriod)
        };
        getBookingPeriod()
    }, [])

    return bookingPeriod
}
